import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

const CategoryCard = ({ category, isHighlighted = false }) => {
  return (
    <div 
      className={`glass-card p-8 category-card cursor-pointer group relative overflow-hidden rounded-2xl ${
        isHighlighted ? 'trading-highlight' : 'border border-cyan-500/10'
      }`}
      data-testid={`category-${category.name}`}
    >
      {/* Animated Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-teal-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Content */}
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-6">
          <div className="text-6xl transform group-hover:scale-110 transition-transform duration-300">
            {category.icon}
          </div>
          {isHighlighted && (
            <div className="flex items-center space-x-1.5 text-cyan-400 text-xs font-bold bg-cyan-500/10 px-3 py-1.5 rounded-full border border-cyan-500/30">
              <Sparkles size={14} />
              <span>HOT</span>
            </div>
          )}
        </div>
        
        <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors">
          {category.name}
        </h3>
        <p className="text-gray-400 text-base leading-relaxed mb-4">
          {category.description}
        </p>

        {/* View More Link */}
        <div className="flex items-center text-cyan-400 text-sm font-semibold opacity-0 group-hover:opacity-100 transform translate-x-0 group-hover:translate-x-2 transition-all duration-300">
          <span>Explore</span>
          <ArrowRight size={16} className="ml-1" />
        </div>
      </div>

      {/* Decorative Corner Element */}
      <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-gradient-to-br from-cyan-500/10 to-teal-500/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Hover Border Effect */}
      <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-cyan-500/20 transition-colors duration-300 pointer-events-none"></div>
    </div>
  );
};

export default CategoryCard;